/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { AbstractResourceService } from '@irian-ro/abstract-resource';
import {EnvironmentService} from "@irian-ro/util-environment";
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class InvitationEmailResourceService extends AbstractResourceService<any, any, any, any> {

  constructor(protected httpClient: HttpClient,
              private environmentService: EnvironmentService) {
    super(httpClient, environmentService.getEnvironmentProperty('invitationEmailUrl'), undefined, undefined, undefined, undefined);
  }

  sendInvitationEmail(legalEntityUuid: string) {
    return this.httpClient
      .post(`${this.url}/${legalEntityUuid}`, null, {headers: this.headers})
      .pipe(this.getDtoMapper());
  }
}
